import { RequestContacts } from '@/types/api/polygon-employee'
import { Step } from '@/types/api/steps'
import { Tasks } from '@/types/api/task'
import { reactive, computed } from 'vue'

const state = reactive({
  request: null as null | Request,
  tasks: null as null | Tasks,
  contacts: null as null | RequestContacts,
  steps: [] as Step[]
})

function storeRequest(request: Request) {
  state.request = request
}

function storeTasks(tasks: Tasks) {
  state.tasks = tasks
}

function storeContacts(contacts: RequestContacts) {
  state.contacts = contacts
}

function storeSteps(steps: Step[]) {
  state.steps = steps
}

export const request = computed(() => state.request)
export const tasks = computed(() => state.tasks)
export const contacts = computed(() => state.contacts)
export const steps = computed(() => state.steps)

export { storeRequest, storeTasks, storeContacts, storeSteps }
